import { useAuth } from '../../contexts/AuthProvider';
import styles from './LoginPage.module.scss';

export function LoginPage() {
    const { signIn, signUp } = useAuth();

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.logo}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="20" stroke="#003366" strokeWidth="3" />
                        <path d="M14 24h20M24 14v20" stroke="#003366" strokeWidth="3" strokeLinecap="round" />
                    </svg>
                </div>
                <h1 className={styles.title}>Expat Horizon</h1>
                <p className={styles.subtitle}>Cross-border wealth management for the global Indian professional</p>
                <button className={styles.cta} onClick={signIn}>
                    Sign In
                </button>
                <button className={styles.ctaSecondary} onClick={signUp}>
                    Create Account
                </button>
                <p className={styles.privacy}>No bank linking required. Your data stays with you.</p>
            </div>
        </div>
    );
}
